'use strict';

var Hounisen = Hounisen || {};
Hounisen.livesearchoverlay = new function () {

    function init() {
        LiveSearchOverlay();
    }


    function LiveSearchOverlay() {


        document.addEventListener("DOMContentLoaded", function () {
            var searchField = document.getElementById("livesearch-input");
            var searchOverlay = document.getElementById("livesearch-overlay");
            var searchOverlayContainer = searchOverlay.getElementsByClassName("container")[0];
            var initialurl = searchOverlay.dataset.url;
            var jsLoader = document.getElementById("livesearch-loader");
            var timeout = null;
            var delay = 500;


            //close if clicked outside container
            document.addEventListener('click', function (event) {
                if (!searchOverlayContainer.contains(event.target)) {
                    CloseOverlay();

                }
            });

            function CloseOverlay() {
                searchOverlay.style.display = "none";
                searchOverlayContainer.innerHTML = "";
            }


            searchField.addEventListener("keyup", function () {
                clearTimeout(timeout);

                if (searchField.value.length > 0) {
                    timeout = setTimeout(function () {
                        jsLoader.classList.add("loader--show");
                        var url = initialurl + "&ListView=gallery" + "&Search=" + searchField.value + "&PageSize=12&Overlay=true&LayoutTemplate=ajax.cshtml";

                        if(searchField.dataset.laege == "True"){
                            url += "&SortBy=-LaegePraksisProduct,-SearchBoost";
                        }

                        // Make AJAX call to URL
                        $.ajax({
                            url: url,
                            type: "GET",
                            success: function (data) {
                                var parser = new DOMParser();
                                var doc = parser.parseFromString(data, "text/html");

                                var fetchedContainer = doc.querySelector("#maincontent");
                                if (fetchedContainer) {

                                    searchOverlayContainer.innerHTML = "";
                                    searchOverlayContainer.appendChild(fetchedContainer.cloneNode(true));
                                    searchOverlay.style.display = "block";
                                    jsLoader.classList.remove("loader--show");


                                    var livesearchClose = document.getElementById("livesearch-overlay__close");

                                    if(LiveSearchOverlay)
                                    {
                                        livesearchClose.addEventListener("click", function () {

                                            CloseOverlay();

                                        });
                                    }
                                }
                            }
                        });
                    }, delay);
                } else {
                    timeout = setTimeout(function () {
                        searchOverlay.style.display = "none";
                        searchOverlayContainer.innerHTML = "";
                        jsLoader.classList.remove("loader--show");
                    }, delay);
                }
            });
        });



    }


    return {
        init: init,
    };
}

();
